import React from "react";
import { TextField } from "@mui/material";
import { useField } from "formik";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { format } from "date-fns";

const FDatePicker = ({ name, ...otherProps }) => {
  const [field, meta, functions] = useField(name);

  const configTextfield = {
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }

  return (
    <DesktopDatePicker
      sx={{
        ".css-e671z5-MuiInputBase-root-MuiOutlinedInput-root.Mui-error": {
          border: "none",
        },
      }}
      disablePast
      error={false}
      onChange={(value) => {
        functions.setValue(
          typeof value === "object" ? format(value, "yyyy/MM/dd") : value
        );
      }}
      value={field.value}
      renderInput={(params) => <TextField {...params} {...configTextfield} />}
    />
  );
};

export default FDatePicker;
